import {metadaApi} from '@dms/api/base';

import {
  CorGetNoteApiApiArg,
  CorGetNoteApiApiResponse,
  CorPutNoteApiApiArg,
  CorPutNoteApiApiResponse,
} from './types';

export const metadaNoteApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getMetadaNote: build.query<CorGetNoteApiApiResponse, CorGetNoteApiApiArg>({
      query: (queryArg) => ({
        url: `/core/v1/note/${queryArg.contextTarget}/${queryArg.contextId}/${queryArg.context}`,
      }),
      providesTags: (result, error, queryArg) => [
        {
          type: 'metadaNote',
          id: `${queryArg.contextTarget}-${queryArg.contextId}-${queryArg.context}`,
        },
      ],
    }),
    putMetadaNote: build.mutation<CorPutNoteApiApiResponse, CorPutNoteApiApiArg>({
      query: (queryArg) => ({
        url: `/core/v1/note/${queryArg.contextTarget}/${queryArg.contextId}/${queryArg.context}`,
        method: 'PUT',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {
          type: 'metadaNote',
          id: `${queryArg.contextTarget}-${queryArg.contextId}-${queryArg.context}`,
        },
      ],
    }),
  }),
});

export const {useGetMetadaNoteQuery, usePutMetadaNoteMutation} = metadaNoteApi;
